module.exports = __webpack_public_path__ + "media/images/lig/flatlay-01-59b91ad4912e7961484d224051be6064.png";